import { mutate as coreMutate } from "@wittignl/js-core";


export default function mutate(apolloClient, mutation, variables, optionsOrUpdateFunction) {

    return coreMutate(apolloClient, mutation, variables, optionsOrUpdateFunction);
}